import React from 'react';
import {
  FaShieldAlt, FaTruck, FaCheckCircle,
  FaArrowRight, FaStar
} from 'react-icons/fa';
import PhoneCTA from './PhoneCTA';
import { MdVerified } from 'react-icons/md';
import ContactForm from './ContactForm';
import { SITE_NAME, SITE_TAGLINE } from '../constants/site';
import './Hero.css';

const trustChips = [
  { icon: FaShieldAlt, label: '90-Day Warranty' },
  { icon: FaTruck, label: 'Fast Nationwide Shipping' },
  { icon: FaCheckCircle, label: 'VIN-Verified Fitment' },
];

const stats = [
  { value: '20+', label: 'Years in Business' },
  { value: '1M+', label: 'Parts in Stock' },
  { value: '50K+', label: 'Happy Customers' },
  { value: '98%', label: 'Satisfaction Rate' },
];

const Hero = () => {
  const scrollToHeroForm = (e) => {
    e.preventDefault();
    const formBlock = document.getElementById('hero-quote');
    if (!formBlock) return;

    formBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
    formBlock.classList.add('hero-form-highlight');

    window.setTimeout(() => {
      formBlock.classList.remove('hero-form-highlight');
      const firstInput = formBlock.querySelector('input');
      firstInput?.focus();
    }, 500);
  };

  return (
    <section className="hero" id="home">
      <div className="hero-bg" aria-hidden="true">
        <div className="hero-gradient" />
        <div className="hero-mesh" />
      </div>

      <div className="hero-body container">
        <div className="hero-left">
          <p className="hero-brand">{SITE_NAME}</p>
          <p className="hero-tagline">{SITE_TAGLINE}</p>

          <h1 className="hero-h1">
            OEM Parts at Up to{' '}
            <span className="hero-h1-accent">30% Less</span>
          </h1>

          <p className="hero-subtext">
            Certified OEM and aftermarket parts — engines, transmissions, alternators, and more —
            with expert fitment checks and no dealership markup.
          </p>

          <div className="hero-eyebrow">
            <MdVerified className="eyebrow-icon" />
            Trusted by 50,000+ Drivers Nationwide
          </div>

          <div className="hero-trust">
            {trustChips.map(({ icon: Icon, label }) => (
              <div className="trust-chip" key={label}>
                <Icon /> {label}
              </div>
            ))}
          </div>

          <div className="hero-ctas">
            <a href="#hero-quote" className="btn-orange hero-cta-main" onClick={scrollToHeroForm}>
              Get Free Quote <FaArrowRight />
            </a>
            <PhoneCTA variant="hero" />
          </div>

          <div className="hero-reviews">
            <div className="review-avatars">
              {['JD', 'MK', 'RS', 'AL'].map((initials) => (
                <div className="review-avatar" key={initials}>{initials}</div>
              ))}
            </div>
            <div className="review-text">
              <div className="review-stars">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} />
                ))}
                <span>4.9/5</span>
              </div>
              <span>Based on 2,400+ verified reviews</span>
            </div>
          </div>
        </div>

        <div className="hero-right" id="hero-quote">
          <ContactForm className="hero-form" />
        </div>
      </div>

      <div className="hero-stats-bar">
        <div className="container stats-grid">
          {stats.map(({ value, label }) => (
            <div className="stat-item" key={label}>
              <strong>{value}</strong>
              <span>{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
